module.exports = __webpack_public_path__ + "static/images/getty-events.2e32fc3d51f7b353ad824489c0a0ebf2.jpg";